module.exports = __webpack_public_path__ + "media/frontend/svg/logo1-df85a01a1e6b9ecfc4cf7ad2eda7f7f2.svg";